import { Component, ElementRef, HostListener, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Ticket } from 'src/app/models/ticket-models/ticket.model';
import { DeskType } from 'src/app/models/turns-models/desk-type.model';
import { SMSBasic } from 'src/app/models/turns-models/turns-sms-basic.model';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-turns-desk-info-card',
  templateUrl: './turns-desk-info-card.component.html',
  styleUrls: ['./turns-desk-info-card.component.scss']
})
export class TurnsDeskInfoCardComponent implements OnInit, OnDestroy, OnChanges {

  @Input() desk;
  @Input() deskTypes: DeskType[];
  @Input() smsList: SMSBasic[];
  @Input() ticketList: Ticket[];
  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  imageBASE64: string;
  centerList;
  editingLocked: boolean;
  refreshDeskListenSubscription: Subscription;
  updateDeskSubscription: Subscription;
  getSmsListSubscription: Subscription;
  getTicketListSubscription: Subscription;
  basicDataForm = new FormGroup({
    name: new FormControl({ value: null, disabled: true }, Validators.required),
    active: new FormControl({ value: false, disabled: true }),
    selectedCenter: new FormControl({ value: null, disabled: true }, Validators.required),
    selectedDeskType: new FormControl({ value: null, disabled: true }, Validators.required),
    deskPrefix: new FormControl({ value: null, disabled: true }),
    canAskCustomerName: new FormControl({ value: false, disabled: true }),
    dailyReset: new FormControl({ value: false, disabled: true }),
    smsNotify: new FormControl({ value: false, disabled: true }),
    selectedSMS: new FormControl({ value: null, disabled: true }),
    notifyPrevious: new FormControl({ value: false, disabled: true }),
    notifyLast: new FormControl({ value: false, disabled: true }),
    canPrint: new FormControl({ value: false, disabled: true }),
    selectedTicket: new FormControl({ value: null, disabled: true }),
    voiceActivate: new FormControl({ value: false, disabled: true }),
    voicePrefix: new FormControl({ value: null, disabled: true }),
    showTurnsAtTotem: new FormControl({ value: false, disabled: true }),
    availableTurn: new FormControl({ value: false, disabled: true }),
    autoAdvance: new FormControl({ value: false, disabled: true }),
    dataType: new FormControl({ value: false, disabled: true }),
    hasVip: new FormControl({ value: false, disabled: true })
  });

  constructor(private desksTurnsService: DesksTurnsService,
    private userStorageService: UserStorageService,
    private snackbarService: SnackBarService,
    private router: Router,
    private eRef: ElementRef) {
      this.editingLocked = true;
  }

  ngOnInit() {
    this.centerList = this.userStorageService.getCenterList();
    this.refreshDeskListenSubscription = this.desksTurnsService.refreshDeskListen().subscribe(
      (res) => {
        this.resetForm();
      }
    );
  }

  ngOnChanges() {
    if (this.desk && this.smsList && this.ticketList) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.desk && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public submitForm() {
    const internalId = this.desk.InternalId;
    const active = this.basicDataForm.get('active').value;
    const name = this.basicDataForm.get('name').value;
    const selectedCenter = this.getSelectedCenter();
    const selectedDeskType = this.getSelectedDeskType();
    const autoAdvance = this.basicDataForm.get('autoAdvance').value;
    let deskPrefix = this.basicDataForm.get('deskPrefix').value;
    let canAskCustomerName = this.basicDataForm.get('canAskCustomerName').value;
    let dailyReset = this.basicDataForm.get('dailyReset').value;
    let voiceActivate = this.basicDataForm.get('voiceActivate').value;
    let voicePrefix = this.basicDataForm.get('voicePrefix').value;
    let smsNotify = this.basicDataForm.get('smsNotify').value;
    let selectedSms = this.getSelectedSMS();
    let notifyPrevious = this.basicDataForm.get('notifyPrevious').value;
    let notifyLast = this.basicDataForm.get('notifyLast').value;
    let canPrint = this.basicDataForm.get('canPrint').value;
    let selectedTicket = this.getSelectedTicket();
    let showTurnsAtTotem = this.basicDataForm.get('showTurnsAtTotem').value;
    let availableTurn = this.basicDataForm.get('availableTurn').value;
    let dataType = null;
    const hasVip = this.basicDataForm.get('hasVip').value;
    switch (this.basicDataForm.get('selectedDeskType').value.InternalId) {
      // NORMAL
      case 'MSHMV1BJ9THXZL9CIYPT25T6R7427OY42':
        deskPrefix = this.basicDataForm.get('deskPrefix').value;
        canAskCustomerName = this.basicDataForm.get('canAskCustomerName').value;
        dailyReset = this.basicDataForm.get('dailyReset').value;
        voiceActivate = this.basicDataForm.get('voiceActivate').value;
        voicePrefix = this.basicDataForm.get('voicePrefix').value;
        smsNotify = this.basicDataForm.get('smsNotify').value;
        selectedSms = this.getSelectedSMS();
        notifyPrevious = this.basicDataForm.get('notifyPrevious').value;
        notifyLast = this.basicDataForm.get('notifyLast').value;
        canPrint = this.basicDataForm.get('canPrint').value;
        selectedTicket = this.getSelectedTicket();
        showTurnsAtTotem = this.basicDataForm.get('showTurnsAtTotem').value;
        availableTurn = this.basicDataForm.get('availableTurn').value;
      break;
      // MULTIPLE_ATTENDING
      case 'MSHMV4BJ9THXZL9CIYPT25T6R7427OY42':
        deskPrefix = this.basicDataForm.get('deskPrefix').value;
        canAskCustomerName = this.basicDataForm.get('canAskCustomerName').value;
        dailyReset = this.basicDataForm.get('dailyReset').value;
        voiceActivate = this.basicDataForm.get('voiceActivate').value;
        voicePrefix = this.basicDataForm.get('voicePrefix').value;
        smsNotify = this.basicDataForm.get('smsNotify').value;
        selectedSms = this.getSelectedSMS();
        notifyPrevious = this.basicDataForm.get('notifyPrevious').value;
        notifyLast = this.basicDataForm.get('notifyLast').value;
        canPrint = this.basicDataForm.get('canPrint').value;
        selectedTicket = this.getSelectedTicket();
        showTurnsAtTotem = this.basicDataForm.get('showTurnsAtTotem').value;
        availableTurn = this.basicDataForm.get('availableTurn').value;
        dataType = this.basicDataForm.get('dataType').value ? dataType = 'NUMERIC' : dataType = 'ALPHANUMERIC';
      break;
      // SINGLE_ROW
      case 'MSHMV2BJ9THXZL9CIYPT25T6R7427OY42':
        deskPrefix = null;
        canAskCustomerName = null;
        dailyReset = null;
        voiceActivate = this.basicDataForm.get('voiceActivate').value;
        voicePrefix = this.basicDataForm.get('voicePrefix').value;
        smsNotify = false;
        selectedSms = null;
        notifyPrevious = false;
        notifyLast = false;
        canPrint = false;
        selectedTicket = null;
        showTurnsAtTotem = null;
      break;
    }
    this.updateDeskSubscription = this.desksTurnsService.updateDeskInfo(internalId, active, name, selectedCenter, selectedDeskType, deskPrefix, canAskCustomerName, dailyReset, voiceActivate, voicePrefix, smsNotify, selectedSms, notifyPrevious, notifyLast, canPrint, selectedTicket, showTurnsAtTotem, availableTurn, autoAdvance, dataType, hasVip).subscribe(
      (res) => {
        this.snackbarService.open('turns-page.snackbar messages.update desk success', 'success');
        this.lockEdition();
        this.desksTurnsService.refreshDesk();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
      }
    }
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'turns-page.snackbar messages.name desk error';
    } else if (!this.basicDataForm.get('selectedCenter').value) {
      return 'turns-page.snackbar messages.selected center desk error';
    } else if (!this.basicDataForm.get('selectedDeskType').value) {
      return 'turns-page.snackbar messages.selected type desk error';
    } else if (this.basicDataForm.get('smsNotify').value && !this.basicDataForm.get('selectedSMS').value) {
      return 'turns-page.snackbar messages.selected sms desk error';
    } else if (this.basicDataForm.get('canPrint').value && !this.basicDataForm.get('selectedTicket').value) {
      return 'turns-page.snackbar messages.selected ticket desk error';
    } else {
      return true;
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      name: this.desk.DeskName,
      active: this.desk.Active,
      selectedCenter: this.setSelectedCenter(),
      selectedDeskType: this.setSelectedDeskType(),
      voiceActivate: this.desk.VoiceActivate,
      voicePrefix: this.desk.VoicePrefix,
      deskPrefix: this.desk.DeskPrefix,
      canAskCustomerName: this.desk.CanAskCustomerName,
      dailyReset: this.desk.dailyReset,
      smsNotify: this.desk.SmsNotifyDesk,
      selectedSMS: this.setSelectedSMS(),
      notifyPrevious: this.desk.NotifyPrevious,
      notifyLast: this.desk.NotifyLast,
      canPrint: this.desk.CanPrint,
      selectedTicket: this.setSelectedTicket(),
      showTurnsAtTotem: this.desk.ShowTurnsAtTotem,
      availableTurn: this.desk.AvailableTurn,
      autoAdvance: this.desk.AutoAdvance,
      dataType: this.desk.DataType === 'NUMERIC' ? true : this.desk.DataType === 'ALPHANUMERIC' ? false : null,
      hasVip: this.desk.HasVip
    });
  }

  public unlockEdition() {
    this.basicDataForm.get('name').enable();
    this.basicDataForm.get('active').enable();
    this.basicDataForm.get('selectedCenter').enable();
    this.basicDataForm.get('voiceActivate').enable();
    this.basicDataForm.get('voicePrefix').enable();
    this.basicDataForm.get('deskPrefix').enable();
    this.basicDataForm.get('canAskCustomerName').enable();
    this.basicDataForm.get('dailyReset').enable();
    this.basicDataForm.get('smsNotify').enable();
    this.basicDataForm.get('selectedSMS').enable();
    this.basicDataForm.get('selectedDeskType').value.TypeCode === 'MULTIPLE_ATTENDING' ? this.basicDataForm.get('notifyPrevious').disable() : this.basicDataForm.get('notifyPrevious').enable();
    this.basicDataForm.get('notifyLast').enable();
    this.basicDataForm.get('canPrint').enable();
    this.basicDataForm.get('selectedTicket').enable();
    this.basicDataForm.get('showTurnsAtTotem').enable();
    this.basicDataForm.get('availableTurn').enable();
    this.basicDataForm.get('autoAdvance').enable();
    this.basicDataForm.get('dataType').enable();
    this.basicDataForm.get('hasVip').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('name').disable();
    this.basicDataForm.get('active').disable();
    this.basicDataForm.get('selectedCenter').disable();
    this.basicDataForm.get('voiceActivate').disable();
    this.basicDataForm.get('voicePrefix').disable();
    this.basicDataForm.get('deskPrefix').disable();
    this.basicDataForm.get('canAskCustomerName').disable();
    this.basicDataForm.get('dailyReset').disable();
    this.basicDataForm.get('smsNotify').disable();
    this.basicDataForm.get('selectedSMS').disable();
    this.basicDataForm.get('notifyPrevious').disable();
    this.basicDataForm.get('notifyLast').disable();
    this.basicDataForm.get('canPrint').disable();
    this.basicDataForm.get('selectedTicket').disable();
    this.basicDataForm.get('showTurnsAtTotem').disable();
    this.basicDataForm.get('availableTurn').disable();
    this.basicDataForm.get('autoAdvance').disable();
    this.basicDataForm.get('dataType').disable();
    this.basicDataForm.get('hasVip').disable();
    this.editingLocked = true;
  }

  public setSelectedCenter() {
    if (this.desk && this.centerList && this.centerList.length > 0) {
      for (const center of this.centerList) {
        if (center.InternalId === this.desk.CenterInternalId) {
          return center;
        }
      }
    } else {
      return null;
    }
  }

  public setSelectedDeskType() {
    if (this.desk && this.deskTypes && this.deskTypes.length > 0) {
      for (const deskType of this.deskTypes) {
        if (deskType.InternalId === this.desk.TurnTypeInternalId) {
          return deskType;
        }
      }
    } else {
      return null;
    }
  }

  public setSelectedSMS() {
    if (this.desk && this.smsList && this.smsList.length > 0) {
      for (const sms of this.smsList) {
        if (sms.InternalId === this.desk.SmsInternalId) {
          return sms;
        }
      }
    } else {
      return null;
    }
  }

  public setSelectedTicket() {
    if (this.desk && this.ticketList && this.ticketList.length > 0) {
      for (const ticket of this.ticketList) {
        if (ticket.InternalId === this.desk.TicketInternalId) {
          return ticket;
        }
      }
    } else {
      return null;
    }
  }

  public getSelectedCenter() {
    if (this.centerList && this.centerList.length > 0) {
      if (this.basicDataForm.get('selectedCenter').value) {
        return this.basicDataForm.get('selectedCenter').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public getSelectedDeskType() {
    if (this.deskTypes && this.deskTypes.length > 0) {
      if (this.basicDataForm.get('selectedDeskType').value) {
        return this.basicDataForm.get('selectedDeskType').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public getSelectedSMS() {
    if (this.smsList && this.smsList.length > 0) {
      if (this.basicDataForm.get('selectedSMS').value) {
        return this.basicDataForm.get('selectedSMS').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public getSelectedTicket() {
    if (this.ticketList && this.ticketList.length > 0) {
      if (this.basicDataForm.get('selectedTicket').value) {
        return this.basicDataForm.get('selectedTicket').value.InternalId;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  public gotoNewSms() {
    this.router.navigate(['turns/parameters/sms']);
  }

  public gotoNewTicket() {
    this.router.navigate(['turns/parameters/ticket']);
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  ngOnDestroy() {
    if (this.refreshDeskListenSubscription) { this.refreshDeskListenSubscription.unsubscribe(); }
    if (this.updateDeskSubscription) { this.updateDeskSubscription.unsubscribe(); }
  }
}
